// extracted by mini-css-extract-plugin
export default {"kitchen-component-cell":"rDvxNmQMMtBtRjxWBv5Q","modified":"EPgsI5t4nhsTbRpkbnOs"};